<template>
    <v-card tile>
        <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.additionalInfo[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
                <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4 pb-1">
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.firstName[lang] }}:
                {{ customerData.first_name ? customerData.first_name : "-" }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.lastName[lang] }}:
                {{ customerData.last_name ? customerData.last_name : "-" }}
            </v-sheet>

             <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.cardNumbers[lang] }}:
                {{ customerData.card_number && customerData.card_number.length > 0 ? customerData.card_number.toString() : "-" }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.address[lang] }}:
                {{ customerData.address ? customerData.address : "-" }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.gender[lang] }}:
                {{ customerData.gender ? customerData.gender : "-" }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.birthDate[lang] }}:
                {{ customerData.birth_date ? customerData.birth_date : "-" }}
            </v-sheet>
        </v-card-text>
    </v-card>
</template>

<script>
import { mdiClose } from "@mdi/js";

import translations from "@/utils/translations/loyaltyPanel/customers";

export default {
    name: "AdditionalInfo",

    mixins: [translations],

    data: () => ({
        icons: { mdiClose },
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        customerData() {           
            return this.$store.state.loyaltyPanel.customers.customerData;  
        },
    }
};
</script>
